import React from "react";
import JalRoLayout from "../components/JalRoLayout";
import {
  ContactCtaSection,
  PageHero,
  ServiceAreasSection,
} from "../components/JalRoSections";

const ServiceAreasPage = () => (
  <JalRoLayout>
    <PageHero
      title="Service Areas"
      text="Doorstep RO water purifier service in Delhi, Noida, Greater Noida, Ghaziabad, Faridabad, and Gurugram."
    />
    <ServiceAreasSection detailed />
    <ContactCtaSection />
  </JalRoLayout>
);

export default ServiceAreasPage;
